import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  plansHeading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  headingWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  description: {
    fontSize: '14px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  headerTitle: {
    color: theme.palette.textField.main,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px !important',
  },
  rowText: {
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
  },
  tableHeader: {
    borderBottom: `1px solid ${theme.palette.detailedOfferBorder.main}`,
  },
  tableCell: {
    padding: `${theme.spacing(1.25, 2, 2, 2)} !important`,
    lineHeight: '1.1rem',
    border: 'none',
    verticalAlign: 'baseline',
  },
  textRight: {
    textAlign: 'right',
  },
  tableInput: {
    '&.MuiFormControl-root': {
      width: theme.spacing(27.5),
    },
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.25),
  },
  checkboxTitle: {
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontWeight: 400,
  },
  row: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  checkbox: {
    height: theme.spacing(3),
    alignSelf: 'flex-end',
  },
  currency: {
    color: theme.palette.labraText.description,
    fontSize: '12px',
    lineHeight: '16px !important',
    textAlign: 'end',
  },
  sectionText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  centerAlign: {
    display: 'flex',
  },
  toolTipIcon: {
    color: theme.palette.textField.main,
    height: theme.spacing(2),
    width: theme.spacing(2),
    padding: theme.spacing(0, 0.75),
    cursor: 'pointer',
  },
}))
